export default __webpack_public_path__ + "005209010c47e1a08e6e055d6248acc4.jpg";